import { render, staticRenderFns } from "./CandidateDetailsWrapper.vue?vue&type=template&id=7f532164"
import script from "./CandidateDetailsWrapper.vue?vue&type=script&lang=js"
export * from "./CandidateDetailsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports